import LocalStorageService from './services/local-storage-service';
import { AppSeason } from './types/theme';

export const DATE = {
  ANTD_DATE_FORMAT: 'DD-MM-YYYY',
  DATE_FORMAT: 'dd-MM-yyyy',
  ANTD_DATE_TIME_FORMAT: 'DD-MM-yyyy HH:mm',
  DATE_TIME_FORMAT: 'dd-MM-yyyy HH:mm',
};
export const RESPONSIVE_WIDTH = 1200;

const atLeastOneUpper = '(?=.*[A-Z])';
const atLeastOneNumber = '(?=.*[0-9])';
const atLeastOneLower = '(?=.*[a-z])';
const atLeast8Chars = '.{8,}';
export const strongPasswordRegex = new RegExp(`^${atLeastOneUpper}${atLeastOneNumber}${atLeastOneLower}${atLeast8Chars}$`);
export const phoneNumberRegex = /^\+\d{7,}$/;

export const imageFallback =
  'data:image/png;base64,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';

export const isTouchDevice =
  'ontouchstart' in window ||
  navigator.maxTouchPoints > 0 ||
  (navigator as unknown as { msMaxTouchPoints: number }).msMaxTouchPoints > 0;

const productionApiEndpoint = 'https://re-sence-core-api.azurewebsites.net';
const testApiEndpoint = 'https://test-re-sence-core-api.azurewebsites.net';
const localApiEndpoint = 'http://localhost:3030';

const productionBlobStorageUrl = 'https://resenceimages.blob.core.windows.net';
const testBlobStorageUrl = 'https://testresenceimages.blob.core.windows.net';

const imagesPath = 'global-images/icons';
const productionImagesUrl = `${productionBlobStorageUrl}/${imagesPath}`;
const testImagesUrl = `${testBlobStorageUrl}/${imagesPath}`;

const productionAppUrls = ['re-sence-core-ui.azurewebsites.net', 'app.re-sence.com', 'app.re-sence.nl', 're-sence.vercel.app'];

const hostname = window && window.location && window.location.hostname;

export const RUNNING_IN_PRODUCTION = productionAppUrls.includes(hostname);
let environmentValue = 'local';

if (import.meta.env.PROD && RUNNING_IN_PRODUCTION) {
  environmentValue = 'production';
} else if (import.meta.env.PROD && !RUNNING_IN_PRODUCTION) {
  environmentValue = 'test';
}

export const ENVIRONMENT = environmentValue as 'local' | 'production' | 'test';

let apiUrl;
if (import.meta.env.PROD && RUNNING_IN_PRODUCTION) {
  apiUrl = productionApiEndpoint;
} else if ((import.meta.env.PROD && !RUNNING_IN_PRODUCTION) || import.meta.env.MODE === 'test') {
  apiUrl = testApiEndpoint;
} else {
  apiUrl = localApiEndpoint;
}

export const API_URL = apiUrl;
export const BLOB_STORAGE_URL = RUNNING_IN_PRODUCTION ? productionBlobStorageUrl : testBlobStorageUrl;
export const IMAGES_URL = RUNNING_IN_PRODUCTION ? productionImagesUrl : testImagesUrl;

const today = new Date();
const YYYY = today.getFullYear();
const getCurrentYearSeason = () => {
  if (today >= new Date(`${YYYY}-05-06`) && today <= new Date(`${YYYY}-08-05`)) {
    return 'summer';
  }

  if (today >= new Date(`${YYYY}-08-06`) && today <= new Date(`${YYYY}-11-05`)) {
    return 'fall';
  }

  if (today >= new Date(`${YYYY}-11-06`) || today <= new Date(`${YYYY}-02-05`)) {
    return 'winter';
  }

  return 'spring';
};

export const APP_SEASON = LocalStorageService.getAppSeason() || (getCurrentYearSeason() as AppSeason);
